import { IconButton, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import React, { useCallback } from "react";
import useDeleteDailyFormInspection from "hooks/fleet/useDeleteDailyFormInspection";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";

interface DailyInspectionActionsCellProps {
  row: any;
  onEditClick: (inspectionId: string) => void;
}

export default function DailyInspectionActionsCell({
  row,
  onEditClick,
}: DailyInspectionActionsCellProps) {
  const [deleteInspection, { isSuccess }] = useDeleteDailyFormInspection();

  const handleEditClick = useCallback(() => {
    onEditClick(row.original.id);
  }, [onEditClick, row.original.id]);

  const acceptFn = useCallback(async (): Promise<boolean> => {
    const { data } = await deleteInspection({
      variables: { id: row.original.id },
    });
    if (isSuccess(data)) {
      return true;
    } else {
      return false;
    }
  }, [deleteInspection, row.original.id, isSuccess]);

  const cancelFn = useCallback(async () => {
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  const handleDeleteClick = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Delete Daily Inspection"
        content="Are you sure you want to delete this daily inspection? This action cannot be undone."
        acceptText="Delete Inspection"
      />

      <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
        <IconButton size="small" color="info" onClick={handleEditClick} title="Edit Inspection">
          <Icon fontSize="small">edit</Icon>
        </IconButton>

        <IconButton
          size="small"
          color="error"
          onClick={handleDeleteClick}
          title="Delete Inspection"
        >
          <Icon fontSize="small">delete</Icon>
        </IconButton>
      </MDBox>
    </>
  );
}
